import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model } from 'libx';
import { observable, action } from 'mobx';
import { task } from 'mobx-task';
import { validationContext, required, func } from 'validx';
import { populateValidationContextFromError } from '../utils/errorUtil';
import { generateSlugFromText } from '../utils/slugUtil';

/**
 * New team state
 */
var NewTeamViewState = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, _dec5 = task.resolved, _class = /*#__PURE__*/function (_Model) {
  function NewTeamViewState(attrs, opts) {
    var _this;
    _classCallCheck(this, NewTeamViewState);
    _this = _callSuper(this, NewTeamViewState, [attrs, opts]);
    _initializerDefineProperty(_this, "showing", _descriptor, _this);
    _initializerDefineProperty(_this, "name", _descriptor2, _this);
    _initializerDefineProperty(_this, "slug", _descriptor3, _this);
    _this.validation = validationContext(_this, {
      name: [required('Team name is required'), func(function (_ref) {
        var value = _ref.value;
        return value.length <= 50;
      }, "Name can't be more than 50 characters")],
      slug: [required('Slug is required'), func(function (_ref2) {
        var value = _ref2.value;
        return value && value.length >= 2 && value.length <= 60 && value.match(/^[a-zA-Z]+[a-zA-Z0-9-]*[a-zA-Z0-9]$/) && !value.match(/([-]{2,})/g);
      }, ['Slug must meet the following requirements:', 'Minimum 2 characters', 'Alphanumeric characters (including dashes)', 'Start and end with a letter', 'No consecutive dashes', 'Maximum 60 characters'])]
    });
    _this.createTeam = _this.createTeam.bind(_this);
    return _this;
  }
  _inherits(NewTeamViewState, _Model);
  return _createClass(NewTeamViewState, [{
    key: "show",
    value: function show() {
      this.name = '';
      this.slug = '';
      this.validation.reset();
      this.showing = true;
    }
  }, {
    key: "suggestSlug",
    value: function suggestSlug() {
      if (this.slug) {
        return;
      }
      this.slug = generateSlugFromText(this.name);
    }
  }, {
    key: "close",
    value: function close() {
      this.showing = false;
    }
  }, {
    key: "validate",
    value: function validate() {
      return this.validation.reset().validate().isValid;
    }
  }, {
    key: "createTeam",
    value: function () {
      var _createTeam = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var msg, team;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.validate()) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              msg = this.rootStore.flashMessageStore.create({
                message: 'Creating team..',
                inProgress: true
              });
              _context.prev = 3;
              _context.next = 6;
              return this.rootStore.teamStore.createTeam({
                name: this.name,
                slug: this.slug,
                workspace_id: this.rootStore.sessionStore.workspace.id
              });
            case 6:
              team = _context.sent;
              _context.next = 9;
              return this.rootStore.teamMemberStore.fetchUserTeamMembersByPublicId({
                team: team.id,
                workspace_id: this.rootStore.sessionStore.workspace.id
              });
            case 9:
              msg.done("Team \"".concat(team.name, "\" was created!")).autoDismiss();
              this.close();
              _context.next = 19;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](3);
              populateValidationContextFromError(this.validation, _context.t0);
              msg.forError(_context.t0);
              msg.autoDismiss(1500);
              throw _context.t0;
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[3, 13]]);
      }));
      function createTeam() {
        return _createTeam.apply(this, arguments);
      }
      return createTeam;
    }()
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "showing", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "name", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "slug", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _applyDecoratedDescriptor(_class.prototype, "show", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "show"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "suggestSlug", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "suggestSlug"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "validate", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "validate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createTeam", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "createTeam"), _class.prototype), _class);
export { NewTeamViewState as default };
//# sourceMappingURL=NewTeamViewState.js.map
